import { Box } from "@/components/layout/flexbox";
import { SubmittedInfo } from "@/components/pieces/coaching/SubmittedInfo";
import { CARD_CLASSES } from "@/css/constants";
import { FullMeeting, FullReview } from "@/types/meetings";
import { NonNullableArrayItem } from "@/types/utils";

type MeetingAnswer = NonNullableArrayItem<
  NonNullable<FullMeeting["formFieldAnswers"]>
>;
type ReviewAnswer = NonNullableArrayItem<
  NonNullable<FullReview["formFieldAnswers"]>
>;
type FormFieldAnswer = MeetingAnswer | ReviewAnswer;

interface SubmittedInformationProps {
  answers: FormFieldAnswer[];
}

export function SubmittedInformation({ answers }: SubmittedInformationProps) {
  if (!answers.length) return null;

  return (
    <Box
      mt={4}
      backgroundColor="#FFF"
      className={CARD_CLASSES}
      p={[3, 3, 24]}
      mb={[24, 24, 24, 0]}
    >
      <Box fontSize={18} fontWeight={500}>
        Submitted Information
      </Box>
      <SubmittedInfo answers={answers} mt={1} />
    </Box>
  );
}
